import { gql } from '@apollo/client';

export const PORTAL_DOCUMENT = gql`
  mutation PortalDocument($docType: String, $method: String, $data: JSON) {
    portalDocument(docType: $docType, method: $method, data: $data)
  }
`;
